import React from 'react';

import RolesHeader from './RolesHeader';
import { useQuery } from 'react-query';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import { API_URL } from '../../../../links/API_LINKS';

const Index = ({ companyId, setValue }) => {
  const fetchOpportunities = async () => {
    const res = await axios.get(API_URL + '/opportunities', {
      params: {
        companyId,
        limit: 0,
        ignoreStatus: true,
      },
    });
    return res;
  };

  const { status, data } = useQuery('fetchOpportunities', fetchOpportunities);

  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <RolesHeader data={data.data.data} setValue={setValue} />
      )}
    </div>
  );
};

export default Index;
